import NewsIndex from "@/containers/NewsIndex";
import ProjectListingPage from "@/containers/ProjectListingPage";
import TeamPage from "@/containers/TeamPage";
import React from "react";
import ContentPage from "../containers/ContentPage";

const PageRouter = ({ data }: { data: any }) => {
	switch (data?.page?.__typename) {
		case "ContentPage":
		case "ProjectPage":
		case "NewsPage":
			return <ContentPage data={data.page} />;
		case "TeamPage":
			return <TeamPage data={data.page} />;
		case "NewsIndex":
			return <NewsIndex data={data.page} />;
		case "ProjectListingPage":
			return <ProjectListingPage data={data.page} />;
		default:
			throw Error(`Unknown Page Type - ${data?.page?.__typename}`);
	}
};

export default PageRouter;
